import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { CityService } from '../../../services';
import { IGlobalSearchParam } from '../../../../shared/models/Global-Search.model';
import { Table } from 'primeng/table';
import { SelectItem } from "primeng/api";
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { City } from '../../../models';
import { IState } from '../../../../applicant/models/city';
import { SharedService } from '../../../../shared/services';
import { CityViewModalComponent } from '../city-view-modal/city-view-modal.component';
import { Router } from '@angular/router';
import * as fs from 'file-saver';

@Component({
  selector: 'app-city-search',
  templateUrl: './city-search.component.html',
  styleUrls: ['./city-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class CitySearchComponent implements OnInit {
  showTopFilters: boolean;
  showFilters: boolean;
  showSorting: boolean;
  oldSortField: string = 'createdOn';
  oldSortOrder: string = 'desc';
  sortField: string = 'createdOn';
  sortOrder: string = 'desc';
  appliedFilters: { field: string, matchMode: string, value: string }[] = [];
  pageNo: number = 1;
  pageSize: number = 10;
  oldPageNo: number = 1;
  oldPageSize: number = 10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  //filterCondition: { fieldName: string; type: string; }[] = [];
  //startSearch: boolean = false;
  cityList;
  gridSpinner = 'gridSpinner1';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  citySearchParam: IGlobalSearchParam;
  items: MenuItem[];
  isCityAdd: boolean = false;
  isCityEdit: boolean = false;
  buttonLabel: string = "";
  title: string = "";
  cityForm: FormGroup;
  ref: DynamicDialogRef;
  dialogPosition = 'topright';
  citySearchSpinner = 'citySearchSpinner';
  states: IState[];
  stateId: any = 1;
  selectedGridMenuItem: any = null;
  showToggle: boolean;
  isshowpaginator: boolean = true;
  statusValues: any;
  selectedStatusId: any = "All";
  selectedStatus: any;

  allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'cityName', header: 'City Name' },
    { value: 'stateName', header: 'State Name' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'cityName', header: 'City Name' },
    { value: 'stateName', header: 'State Name' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  @ViewChild('dt2', { static: true }) table: any;
  createdOnFilterValue: any;
  filterCondition = [
    { fieldName: "cityName", type: "basic" },
    { fieldName: "stateName", type: "basic" },
    { fieldName: "isActive", type: "basic" },
    { fieldName: "createdBy", type: "basic" },
    { fieldName: "createdOn", type: "date" },
  ];
  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private cityService: CityService,
    private _fb: FormBuilder,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public sharedService: SharedService,
    private _router: Router
  ) {
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);

    /*this.items = [
      {
       label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editCityDetails(this.selectedGridMenuItem.cityId)
      },
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.cityId)
      }
   ];*/
    //this.currentUser = this.storage.retrieve('currentuser');

  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();
    this.appliedFilters.push({ field: "globalfilter", matchMode: "equals", value: "0" })
    this.getCityList();
    this.statusValues = [
      { description: 'All', id: 'All' },
      { description: 'Active', id: 'Active' },
      { description: 'Inactive', id: 'Inactive' }
    ];
    this.InitialSetup();
    //this.getStates();
  }

  checkAdminView() {
    var result = this.sharedService.checkPermission("Admin_View");
    if (!result)
      this._router.navigateByUrl('/login');
  }

  InitialSetup() {
    this.cityForm = this._fb.group({
      cityId: new FormControl(0, [Validators.required]),
      cityName: new FormControl("", [Validators.required]),
      stateId: new FormControl(0, [Validators.required]),
      isActive: new FormControl(false, [Validators.required]),
      countryId: new FormControl(1),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  checkViewPermission() {
    var result = this.sharedService.checkPermission("Admin_View");
    if (!result)
      this._router.navigateByUrl('/login');
  }

  getStates() {
    this.sharedService.getStates().subscribe((data: any) => {
      this.states = data;
      this.cityForm.get('stateId').setValue(this.states[0].stateId);
    });
  }

  getCityList() {
    this.loading = true;
    this.citySearchParam =
    {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      sortField: this.sortField,
      appliedFilters: this.appliedFilters,
      sortOrder: this.sortOrder
    };
    this.cityService.getAllCity(this.citySearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.cityList = data;
      this.isshowpaginator = this.cityList.length > 0 ? true : false;
      this.totalRecords = data[0].totalCount;
      this.loading = false;
    });
  }

  loadCityList(event: LazyLoadEvent) {
    this.loadEvent = event;
    if (event.first == 0) {
      this.pageNo = 1;
    }
    else {
      this.pageNo = (event.first / event.rows) + 1;
    }
    this.pageSize = event.rows;

    if ((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize)) {
      this.applyFilter();
      //this.getCityList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters = event.filters;
    this.sortField = event.sortField;
    if (event.sortField === undefined || event.sortField === null) {
      this.sortField = 'createdOn';
    }
    if (event.sortOrder === 1) {
      this.sortOrder = 'desc';
    }
    if (event.sortOrder === -1) {
      this.sortOrder = 'asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getCityList()
    }*/

    if (this.oldSortField !== this.sortField || this.oldSortOrder !== this.sortOrder) {
      this.applyFilter();
      //this.getCityList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  cancel() {
    this.isCityAdd = false;
    this.isCityEdit = false;
  }

  addCityDetails() {
    this.InitialSetup();
    this.getStates();
    this.isCityAdd = true;
    this.isCityEdit = false;
    this.title = "City Add";
    this.buttonLabel = "Save";
  }

  editCityDetails(paramId: number) {
    this.InitialSetup();
    this.getStates();
    this.isCityEdit = true;
    this.isCityAdd = false;
    this.title = "City Edit";
    this.buttonLabel = "Update";
    this.cityService.getCityDetail(paramId).subscribe((data: City) => {
      this.cityForm.patchValue(data);
    }, error => {
      console.log(error)
    })
  }

  showCityDetails(paramId: number) {
    this.ref = this.dialogService.open(CityViewModalComponent, {
      header: 'City Details',
      width: '50%',
      contentStyle: { "max-height": "500px", "overflow": "auto" },
      baseZIndex: 10000,
      data: { id: paramId }
    });
  }

  deleteConfirm(paramId: number) {
    this.dialogPosition = 'topright';
    //console.log('deleteConfirm deleteConfirm ');
    this.confirmationService.confirm({
      message: 'Do you want to delete this city?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        // console.log("hi");
        this.cityService.deleteCityDetail(paramId).subscribe((data: any) => {
          this.getCityList();
          this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have deleted the record' });
        });
      },
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      },
      key: "positionDialog"
    });
  }

  save({ value }: { value: City }) {
    // console.log(value);
    value.countryId = 1;
    if (value.cityId == 0) {
      //value.stateId=this.stateId;
      value.createdBy = 1;
      value.createdOn = new Date();
      this.cityService.postCityDetail(value).subscribe(data => {
        this.getCityList();
        this.isCityAdd = false;
      }, error => {
        console.log(error)
      })
    } else {
      //  console.log("Edit");
      this.cityService.updateCityDetail(value.cityId, value).subscribe(data => {
        this.getCityList();
        this.isCityEdit = false;
      }, error => {
        console.log(error);
      })
    }
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.createdOnFilterValue = undefined;
    this.appliedFilters = [];
    //this.applyFilter();
    this.getCityList();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }

  applyFilter() {
    if (Object.keys(this.filters).length >= 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "basic") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            //createdOn
            if (this.filterCondition[i].fieldName == "createdOn") {
              this.dateFilterValueSet(this.createdOnFilterValue, "createdOn")
            }
          }
        }
      }
    }

   // if (this.startSearch == true || this.startSearch == false) {
      this.citySearchParam =
      {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        sortField: this.sortField,
        appliedFilters: this.appliedFilters,
        sortOrder: this.sortOrder
      };
      this.loading = true;
      this.cityService.getAllCity(this.citySearchParam).subscribe((data: any) => {
        this.loading = false;
        this.cityList = data;
        this.isshowpaginator = this.cityList.length > 0 ? true : false;
        this.totalRecords = data[0].totalCount;
      });
   // }
  }

  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datepipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }

  exportCity() {
    //this.applyFilter();
    this.citySearchParam =
    {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      sortField: this.sortField,
      appliedFilters: this.appliedFilters,
      sortOrder: this.sortOrder
    };
    this.cityService.ExportCityResult(this.citySearchParam).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob], "City.xlsx", { type: res.body.type });
      fs.saveAs(file);
    });
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event) {
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName) {
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if (tempColumn.length == 1) {
      // console.log("length is "+tempColumn.length);
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        command: e => this.editCityDetails(this.selectedGridMenuItem.cityId)
      }
      this.items.push(editItem)
    }
    if (isAdminDelete) {
      var deleteItem = {
        label: 'Delete',
        icon: 'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.cityId)
      }
      this.items.push(deleteItem);
    }
  }

  createdOnFilterData(e: any) {
    this.createdOnFilterValue = e;
    this.applyFilter();
  }

  getFilterName(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      return tempStatus[0].description
    } else {
      return "";
    }
  }

}
